import Vue from "vue/dist/vue.js";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

import {login_ru, login_kz} from "./auth/login";
import {validations_ru, validations_kz} from "./validations/validations";

import {check_ru, check_kz} from "./registration/00_check";
import {
    registration_ru,
    registration_kz
} from "./registration/01_registration";
import {
    personal_info_ru,
    personal_info_kz
} from "./registration/02_personal-info";

const messages = {
    ru: {
        registration: {
            check: check_ru,
            registration: registration_ru,
            personal_info: personal_info_ru
        },
        login: login_ru,
        validation: validations_ru
    },
    kz: {
        registration: {
            check: check_kz,
            registration: registration_kz,
            personal_info: personal_info_kz
        },
        login: login_kz,
        validation: validations_kz
    }
};

const i18n = new VueI18n({
    locale: "ru",
    fallbackLocale: "ru",
    messages
});

Object.defineProperty(Vue.prototype, "$locale", {
    get: function () {
        return i18n.locale;
    },
    set: function (locale) {
        i18n.locale = locale;
    }
});

export default i18n;
